import { useEffect, useRef, useState } from "react";
import { Camera, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

// Live camera only (no gallery): getUserMedia preview + snapshot to JPEG blob.
export const CameraCapture = ({ onCapture }) => {
  const video = useRef(null);
  const [err, setErr] = useState("");
  const [shot, setShot] = useState(null);
  useEffect(() => {
    let stream;
    if (!navigator.mediaDevices?.getUserMedia) {
      setErr("Questo dispositivo o browser non consente l'uso della fotocamera.");
      return undefined;
    }
    navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: "environment" }, width: { ideal: 1920 } }, audio: false })
      .then((s) => {
        stream = s;
        if (video.current) video.current.srcObject = s;
      })
      .catch(() => setErr("Fotocamera non disponibile: concedi il permesso alla fotocamera nel browser e riprova."));
    return () => stream?.getTracks().forEach((t) => t.stop());
  }, []);
  const snap = () => {
    const v = video.current;
    const c = document.createElement("canvas");
    c.width = v.videoWidth;
    c.height = v.videoHeight;
    c.getContext("2d").drawImage(v, 0, 0);
    c.toBlob((b) => {
      setShot(URL.createObjectURL(b));
      onCapture(b);
    }, "image/jpeg", 0.9);
  };
  const retake = () => {
    setShot(null);
    onCapture(null);
  };
  if (err) return <p className="rounded-xl bg-red-50 p-4 text-sm font-semibold text-red-700" data-testid="camera-error">{err}</p>;
  return (
    <div className="space-y-2" data-testid="camera-capture">
      <div className="relative overflow-hidden rounded-xl bg-black">
        <video ref={video} autoPlay playsInline muted className={shot ? "hidden" : "aspect-[4/3] w-full object-cover"} data-testid="camera-video" />
        {shot && <img src={shot} alt="Foto scattata" className="aspect-[4/3] w-full object-cover" data-testid="camera-preview" />}
      </div>
      {shot ? <Button variant="outline" onClick={retake} className="w-full rounded-xl" data-testid="camera-retake"><RefreshCw className="mr-1 h-4 w-4" />Rifai la foto</Button>
        : <Button onClick={snap} className="h-12 w-full rounded-xl text-base font-bold" data-testid="camera-shoot"><Camera className="mr-1 h-5 w-5" />Scatta</Button>}
    </div>
  );
};
